module.exports = __webpack_public_path__ + "static/rick-001-33d1b149e6636427ca979639dae13f28.jpg";